import React, {Component} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import SimpleAccordionItem from './SimpleAccordionItem'

class SimpleAccordionContainer extends Component {
    constructor(props) {
        super(props)

        this.isIndexInList = this.isIndexInList.bind(this)
        this.toggleItem = this.toggleItem.bind(this)

        this.state = {
            openedItems: this.props.defaultClosed ? [] : [0]
        }
    }

    toggleItem(index, propsFunction) {
        var openedItems = this.state.openedItems
    
        if(this.props.collapsable) {
            if(!this.isIndexInList(index)) {
                this.setState({
                    openedItems: [index]
                })
            } else {
                this.setState({
                    openedItems: []
                })
            }
        } else {
            if(this.isIndexInList(index)) {
                this.setState({
                    openedItems: openedItems.filter(function(value) {return value != index})
                })
            } else {
                openedItems.push(index)
                this.setState({
                    openedItems: openedItems
                })
            }
        }
    
        propsFunction && propsFunction()
    }
    

    isIndexInList(index) {
        return this.state.openedItems.includes(index)
    }

    render() {
        const {
            isIndexInList,
            toggleItem,
            props: { expand },
            state: { openedItems }
        } = this

        return (
            <div className={cx('accordion-container', expand)}>
                {
                    React.Children.map(this.props.children, (child, index) =>
                      React.cloneElement(child, { expand, onClick: () => toggleItem(index, child.props.onClick), opened: isIndexInList(index), key: `accordion-clone-item-${index}` })
                    )
                }
            </div>
        )
    }
}

SimpleAccordionContainer.defaultProps = {
    expand: 'text'
}

SimpleAccordionContainer.propTypes = {
    children: PropTypes.arrayOf(SimpleAccordionItem),
    expand: PropTypes.string,
}

export default SimpleAccordionContainer


// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Accordion/SimpleAccordionContainer.jsx